// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"checkbox_checkmark__37ZzZ","checked":"checkbox_checked__3IxkD","line":"checkbox_line__1lsE_"};